import { render, staticRenderFns } from "./genQrCode.vue?vue&type=template&id=875b2ea2"
import script from "./genQrCode.vue?vue&type=script&lang=js"
export * from "./genQrCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports